import { PartFinderActivityList } from '@/components/PartFinder/PartFinderActivityList';
import { PartFinderForm } from '@/components/PartFinder/PartFinderForm';
import { SectionHeading } from '@/components/PartFinder/SectionHeading';
import { usePageTitle } from '@/hooks/usePageTitle';
import { ManageSearchOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const MainContentArea = styled(Box)({
  flex: 1,
  display: 'flex',
  height: '100%',
  minHeight: 0,
  flexDirection: 'column',
  justifyContent: 'flex-start',
  width: '100%',
  overflow: 'hidden',
  padding: '24px',
});

const SectionSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
  marginBottom: '16px',
}));

export const PartFinderPage = () => {
  usePageTitle('Part Finder');

  return (
    <MainContentArea>
      <SectionHeading variant='page' icon={<ManageSearchOutlined />} title='Find a Part' />
      <SectionSubtitle>
        Search by NSN, NIIN, or part name to generate a sourcing report with manufacturers, technical characteristics,
        and procurement options. Past searches also match by their description.
      </SectionSubtitle>
      <PartFinderForm />
      <PartFinderActivityList />
    </MainContentArea>
  );
};
